import {doQuerySafe} from 'graphql-client/ApolloWrappers';

import {
  FetchSelectorsByIdQuery,
  FetchSelectorsByIdQueryVariables,
} from '../hooks/__generated/FetchSelectorsByIdQuery';
import {
  convertFetchSelectorsQueryResultToSchemaFieldSelectorsDict,
  FETCH_SELECTORS_BY_ID_QUERY,
  SchemaFieldSelectorsDict,
} from '../hooks/useSelectorsById';

export default async function fetchSelectorsById(
  includeArchived: boolean
): Promise<SchemaFieldSelectorsDict> {
  const result = await doQuerySafe<FetchSelectorsByIdQuery, FetchSelectorsByIdQueryVariables>(
    {
      query: FETCH_SELECTORS_BY_ID_QUERY,
    },
    {
      variables: {
        includeArchived,
      },
    }
  );

  return convertFetchSelectorsQueryResultToSchemaFieldSelectorsDict(result);
}
